import { RAISE_API_V1_URL, RAISE_BASE_URL } from "constants/endpoints";
import { get } from "services/api";

/**
 * Fetch session info request and returns a promise with attributes in snake case.
 *
 * @typedef {Object} UserObject
 * @param {string|null} user_uuid User's UUID or null.
 * @param {string|null} guest_user_uuid UUID of the guest user or null.
 * @param {string|null} user_phone User's phone number or null.
 * @param {string|null} average_order_total Average order total or null.
 * @param {Array} user_roles List of user roles (empty if no roles assigned).
 * @param {boolean|null} device_verified Indicates if the device has been verified, or null if not applicable.
 * @param {boolean|null} email_confirmed Indicates if the email has been confirmed, or null if not applicable.
 *
 * @typedef {Object} FeatureToggles
 * @param {boolean} unified_cart Indicates if the unified cart is enabled.
 * @param {boolean} affiliate_program Indicates if the affiliate program is enabled.
 * @param {boolean} sardine_enabled Indicates if the "Sardine" feature is enabled.
 * @param {boolean} group_listings Indicates if group listings are enabled.
 * @param {boolean} decagon_enabled Indicates if the "Decagon" feature is enabled.
 *
 * @typedef {Object} UserSessionResponse
 * @param {boolean} logged_in Indicates if the user is logged in.
 * @param {UserObject} user
 * @param {FeatureToggles} feature_toggles
 *
 * @returns {Promise<UserSessionResponse>} A promise that resolves with the processed user session info in snake_case format.
 */
export const getSessionInfo = async () => {
  const response = await get(`${RAISE_API_V1_URL}/session_info`);

  return response.data;
};

export const getLegacySessionInfo = async () => {
  const response = await get(`${RAISE_BASE_URL}/session_info.json`, {
    withCredentials: true
  });
  return response.data;
};
